// 🔧 index.js
// ✅ Purpose: Sponsor Engine entry point
// ✅ Features:
// - Executes Sponsor Engine
// - Coordinates Sponsor Builder
// - Future-ready for Sponsor Levels, Awards, and Reporting
// - Fully block-commented for clarity and future devs

import { buildSponsors } from "./sponsor_builder";

export const runSponsorEngine = async ({
  demoContext,
} = {}) => {
  console.log("🤝 Sponsor Engine started.");

  const result = await buildSponsors({
    demoContext,
  });

  console.log("✅ Sponsor Engine completed.");

  return result;
};